import { Card, CardContent, CardMedia, Chip, Grid, Link, Stack, TextField, Typography, useTheme, Button} from "@mui/material";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { NO_IMAGE } from "../config/config";
import { useSubCategoryArticles } from '../hooks/useSubCategoryArticles'
import { useBlogs } from '../hooks/useBlogs'

import useMediaQuery from '@mui/material/useMediaQuery';
import { getString } from "../functions/getString";
import { useArticleCategories } from "../hooks/useArticleCategories";
import Loading from '../components/Loading/loading'
import NoDataComponent from '../components/nodata/nodata'
import { SearchRounded } from "@mui/icons-material";
import ArticleCardSkeleton from '../components/articles/articleCardSkeleton'

const CustomArticles = ({ item, parentItem, ...props }) => {

    const { reducer } = useSelector((state) => state);
    const { isSiteBuilder } = reducer;

    const [isLoading, setLoading] = useState(true);
    const [allArticles, setAllArticles] = useState([])
    const [allCategories, setAllCategories] = useState([])
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [total, setTotal] = useState(0);

    const { articles } = parentItem || {};

    const getArticleCategories = async () => {
        const result = await useArticleCategories()
        setAllCategories(result)
        if(Array.isArray(result) && result?.length > 0)
        {
            setSelectedCategory(result[0])
        }
    }

    useEffect(() => {
        getArticleCategories()
    }, [])
    
    const getBlogData = async () => {
        setLoading(true)
        const result = await useBlogs(selectedCategory?.ac_slug)
        setAllArticles(result)
        setLoading(false)
    }

    useEffect(() => {
        getArticleData()
    }, [])
   
    const theme = useTheme();
    const { push } = useRouter();
    const isSmScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const DIVIDER = theme.palette.divider;

    const [searchText, setSearchText] = useState('')

    const [filterdData, setFilteredData] = useState([])

    const getArticleData = async () => {
        setLoading(true)
        const result = await useSubCategoryArticles(`?slugs=${articles?.toString()}`)
        const totalCount = result?.totalCount;
        console.log(totalCount, "totalCount");
        
        setTotal(totalCount)
        
        setAllArticles(result?.data)
        setFilteredData(result?.data)
        setLoading(false)
    }

    
function searchCourses(title){
        
    const newData = allArticles.filter(item => {
        const itemData = item.a_title.toUpperCase()
        const textData = searchText.toUpperCase()
        return itemData.indexOf(textData) > -1
    })

    setFilteredData(newData)

}

useEffect(() => {
    searchCourses()
}, [searchText])

    
    return (
        <Stack>

            <TextField
                value={searchText}
                contentEditable={isSiteBuilder}
                onChange={(e) => {
                    if (isSiteBuilder) {
                        item.props = { ...item.props, searchPlaceholder: e.target.value };
                        setSearchText(e.target.value)
                    } else {
                        setSearchText(e.target.value);
                    }
                }}
                fullWidth
                placeholder={item?.props?.searchPlaceholder ?? "Search articles"}
                InputProps={{
                    startAdornment: <SearchRounded/>
                }}
                sx={{
                    width: '100%',
                    mt: 4
                }}
            />

            {/* <Stack direction={'row'} gap={2} my={2} overflow={'hidden'} sx={{ overflowX: 'scroll' }} className={'hide-scrollbar'} px={2} alignSelf={'center'} maxWidth={'100vw'} >
                {
                    allCategories?.map((item, index) => {

                        const isSelected = item?.id == selectedCategory?.id

                        return(
                            <Chip 
                                label={item?.label} 
                                sx={{
                                    bgcolor: isSelected ? '#000' : 'grey.200',
                                    color: isSelected ? '#fff' : 'grey.800'
                                }}
                                onClick={() => {
                                    setSelectedCategory(item)
                                }}
                            />
                        )
                    })
                }
            </Stack> */}

            {
                !isLoading && !isSiteBuilder && filterdData?.length < 1 &&
                <NoDataComponent
                    title={'No articles found'}
                />
            }

            

            <Grid container mt={5} mb={4}  spacing={isSiteBuilder ? 0 : 3}>

                {/* {
                    isSiteBuilder && Array(5)?.fill(1)?.map((item, index) => {
                        return (
                            <Grid item xl={2.4} lg={3} md={4} sm={6} xs={12} key={index} >
                                <Card 
                                    sx={{ 
                                        borderRadius: "0 0 8px 8px",
                                        '&:hover': {
                                            boxShadow: 'none'
                                        },
                                        border: `1px solid ${DIVIDER}`,
                                        // height: '100%'
                                    }}
                                >
                                    <CardMedia
                                        image={NO_IMAGE}
                                        component="img"
                                        height={200}
                                    />
                                    <CardContent>
                                        <Typography mb={1} fontSize={12} >{getString('Article')}</Typography>
                                        <Typography>{getString('Article name here')}</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        )
                    })
                } */}

                {
                    !isSiteBuilder && filterdData?.map((item, index) => {
                        return (
                            <Grid item xl={2.4} lg={3} md={4} sm={6} xs={12} key={index} spacing={2} >
                                <Link href={`/articles/${item?.a_slug}`} underline="none">
                                    <Card 
                                        sx={{ 
                                            borderRadius: "0 0 8px 8px",
                                            cursor: 'pointer',
                                            '&:hover': {
                                                boxShadow: 'none'
                                            },
                                            border: `none`,
                                            // height: '100%'
                                        }}
                                    >
                                        
                                        <Stack height={185} >
                                            <img src={item?.a_image} style={{ height: '100%', width: '100%' }} />
                                        </Stack>
                                        <CardContent style={{textAlign: isSmScreen ? "center" : "",}}>
                                            <Typography mb={1} fontSize={12} >{getString('Article')}</Typography>
                                            <Typography>{item?.a_title}</Typography>
                                        </CardContent>
                                    </Card>
                                </Link>
                            </Grid>
                        )
                    })
                }
                {
                isSiteBuilder && 
                <Grid container spacing={2} mt={2} >
                    {
                        Array(5).fill(1).map((item,index) =>{
                            return(
                                <Grid item xl={2.4} lg={3} md={4} sm={6} xs={12}  key={index}>
                                   <ArticleCardSkeleton/>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            }
                
                

            </Grid>
            {(isSiteBuilder || total > 10) && (
                <Grid xs={12} textAlign="center" mt={3}>
                    <Button
                        variant="outlined"
                        size="large"
                        sx={{ borderRadius:"999px" , cursor: isSiteBuilder ?"text" : "pointer", textTransform:"none" }}
                        onClick={() => !isSiteBuilder && push("/articles")}
                    >
                        <span
                            data-sb-label="show-more"
                            contentEditable={isSiteBuilder}
                            style={{ cursor :isSiteBuilder ? "text" : "pointer", outline:"none" }}
                        >
                            {item?.props?.showMoreLabel ?? "Show more"}
                        </span>
                    </Button>
                </Grid>
            )}

        </Stack>
    )
};

export default CustomArticles;